import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { ContextoService } from '@core/services/contexto.service';
import { esRolAdmin } from '@core/constants/roles.constants';
import { RUTAS } from '@core/constants/rutas.constants';
import { MODOS_SISTEMA } from '@core/constants/modos.constants';


export const flujoPostLoginGuard: CanActivateFn = () => {
  const contextoService = inject(ContextoService);
  const router = inject(Router);

  const contextoActivo = contextoService.obtenerContextoActivo();
  
  if (contextoActivo?.modo) {
    return true;
  }
  const orgRoles = contextoService.obtenerOrgRolesJWT() || [];
  
  if (orgRoles.length === 0) {
    return true;
  }

  const esAdmin = orgRoles.some(or => esRolAdmin(or.role));

  if (esAdmin) {
    void router.navigate([RUTAS.SELECCION_MODO]);
    return false;
  } else {
    contextoService.establecerModoSinContexto(MODOS_SISTEMA.OPERATIVO);
    void router.navigate([RUTAS.PERFILES_EMPRESAS], {
      state: { modo: MODOS_SISTEMA.OPERATIVO }
    });
    return false;
  }
};
